import Terms from "../components/Terms/Terms";

export default function TermsAndConditions() {
  return <Terms />;
}
